<template>
  <router-link class="nav-link" :to="to" v-bind="$attrs">
    <div
      class="text-center bg-white shadow icon icon-shape icon-sm border-radius-md d-flex align-items-center justify-content-center"
      :class="this.$store.state.isRTL ? ' ms-2' : 'me-2'"
    >
      <slot name="icon"></slot>
    </div>
    <span
      class="nav-link-text"
      :class="this.$store.state.isRTL ? ' me-1' : 'ms-1'"
      >{{ navText }}</span
    >
  </router-link>
</template>
<script>
export default {
  name: "sidenav-collapse",
  props: {
    to: {
      type: [Object, String],
      required: true,
    },
    navText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
};
</script>

<style scoped>
.nav-link {
  border-radius: 0.75rem;
  transition: background 0.2s ease, transform 0.15s ease;
}

.nav-link:hover {
  background: rgba(23, 193, 232, 0.08);
  transform: translateX(3px);
}

.nav-link .icon {
  transition: transform 0.2s ease;
}

.nav-link:hover .icon {
  transform: scale(1.08);
}
</style>
